import { ResourceTagDto } from '@act/shared/data-transfer-objects';
import {
  EntityId,
  createAction,
  createEntityAdapter,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import { addToEffectsMiddleware } from 'redux/utils/effects-middleware';
import { resourceRequests } from '../requests/resources.requests';
import { createApiThunk } from '../utils/api-thunk';
import { resetRedux } from '../actions/shared-actions';

// THUNKS/ACTIONS ==============================================================
export const getResourceTags = createApiThunk(resourceRequests.getResourceTags);
export const loadResourceTags = createAction('resources/loadTags');

// INITIAL STATE ===============================================================
const resourceTagAdapter = createEntityAdapter<ResourceTagDto, EntityId>({
  selectId: tag => tag.key,
});
const initialState = resourceTagAdapter.getInitialState({
  loaded: false,
  loading: false,
});
const selectResourceTagsState = state =>
  (state as { resourceTags: typeof initialState })?.resourceTags;

// SLICE =======================================================================
export const resourceTagsSlice = createSlice({
  name: 'resourceTags',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(resetRedux, state => {
        state = { ...initialState };
        return state;
      })
      .addCase(getResourceTags.pending, state => {
        state.loading = true;
      })
      .addCase(getResourceTags.fulfilled, (state, action) => {
        state.loaded = true;
        state.loading = false;
        return resourceTagAdapter.addMany(state, action.payload);
      })
      .addCase(getResourceTags.rejected, state => {
        state.loading = false;
      });
  },
});

// REDUCER =====================================================================
export const resourceTagsReducer = resourceTagsSlice.reducer;

// SELECTORS ===================================================================
export const {
  selectAll: selectAllResourceTags,
  selectById: selectResourceTagById,
} = resourceTagAdapter.getSelectors(selectResourceTagsState);

export const selectResourceTagsLoading = createSelector(
  selectResourceTagsState,
  state => state.loading
);

// EXPORT HELPER ===============================================================

// EFFECTS =====================================================================
addToEffectsMiddleware(addEffect => {
  addEffect({
    action: loadResourceTags,
    effect: async ({ dispatch, state }) => {
      const resourceState = selectResourceTagsState(state);
      if (!resourceState.loaded && !resourceState.loading) {
        dispatch(getResourceTags({}));
      }
    },
  });
});

// WEBSOCKET ACTIONS ===========================================================
